module.exports = __webpack_public_path__ + "img/IMG-20200606-WA0012.fe9256ff.jpg";